import qs from 'qs'
import _ from 'lodash'

const getQuery = () => {
  const {
    search
  } = window.location

  const values = qs.parse(search.replace('?', ''))

  return getValidValues(values)
}

const getValidValues = (values) => {
  return _.transform(values, (result, val, key) => {
    if (val && val !== 'undefined') {
      result[key.toLowerCase()] = val
    }
  })
}

const getModel = (model) => {
  return _.transform(model, (result, val, key) => {
    result[key.toLowerCase()] = val
  })
}

const getchangedQuery = (model) => {
  const data = Object.assign(getQuery(), getModel(model))
  return qs.stringify(getValidValues(data))
}

const updateQuery = (model) => {
  const data = getchangedQuery(model)
  window.history.pushState(model, '', `?${data}`)
}

export default {
  getQuery,
  getchangedQuery,
  updateQuery
}
